import Swiper from 'swiper'


// ACTUALITES
let actualitesSize = document.querySelectorAll('.ac .swiper-slide').length;

let actualitesConfig = {
    effect : 'slide',
    grabCursor : 'true',
    speed: 700,
    loop: true,

    keyboard: {
        enabled: true,
    },

    mousewheel: {
        forceToAxis: true,
        releaseOnEdges : true,
    },

    navigation: {
        prevEl: '.ac-navigation__item--prev',
        nextEl: '.ac-navigation__item--next',
    },

    breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20
        },

        640: {
            slidesPerView: 2,
            spaceBetween: 20
        },

        1200: {
            slidesPerView: 2,
            spaceBetween : 30,
        }
      }
}


let actualites = new Swiper('.ac .swiper-container', actualitesConfig);



// AGENDA
let agendaSize = document.querySelectorAll('.ag .swiper-slide').length;

let agendaConfig = {
    effect : 'slide',
    grabCursor : 'true',
    // loop : 'true',
    speed: 700,

    keyboard: {
        enabled: true,
    },

    mousewheel: {
        forceToAxis: true,
        releaseOnEdges : true,
    },

    navigation: {
        prevEl: '.ag-navigation__item--prev',
        nextEl: '.ag-navigation__item--next',
    },

    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 20
        },

        641: {
            slidesPerView: 2,
            spaceBetween: 20
        },

        961: {
            slidesPerView: 3,
            spaceBetween: 20
        },

        1201: {
            spaceBetween : 30,
            slidesPerView: 3,
        }
      }
}

let agenda = new Swiper('.ag .swiper-container', agendaConfig);